import { render, staticRenderFns } from "./ConstraintsForm.vue?vue&type=template&id=1da3d660&"
import script from "./ConstraintsForm.vue?vue&type=script&lang=js&"
export * from "./ConstraintsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports